
/**
 * ProduPneu — Authentication & Role Guards
 * Vue 2 + Vue Router 3 + Vuex
 */

export function createGuards({ router, store }) {
  router.beforeEach(async (to, from, next) => {
    try {
      // Restore authentication session only once.
      if (!store.state.auth.bootstrapped) {
        await store.dispatch("auth/bootstrap");
      }

      const user = store.state.auth.user;
      const roles = store.state.auth.roles || [];
      const isAuthenticated = Boolean(user);

      // Roles accepted by this route.
      // Supports both "roles" and legacy "role".
      const allowedRoles =
        to.meta.roles ||
        (to.meta.role ? [to.meta.role] : []);

      // 1. Authentication required
      if (to.meta.requiresAuth && !isAuthenticated) {
        return next({
          path: "/login",
          query: {
            redirect: to.fullPath,
          },
        });
      }

      // 2. Role authorization
      if (
        allowedRoles.length > 0 &&
        !allowedRoles.some(role => roles.includes(role))
      ) {
        if (!isAuthenticated) {
          return next({
            path: "/login",
            query: { redirect: to.fullPath },
          });
        }

        return next({ path: "/403" });
      }

      // 3. Prevent authenticated users from visiting login/register
      if (
        isAuthenticated &&
        ["/login", "/register"].includes(to.path)
      ) {
        if (roles.includes("admin")) {
          return next("/admin");
        }

        if (roles.includes("garage")) {
          // Only enable when the garage dashboard exists.
          return next("/");
        }

        return next("/account");
      }

      // 4. Allow access
      return next();

    } catch (error) {
      console.error("Router guard error:", error);

      // Deny access to protected routes on unexpected errors.
      if (to.meta.requiresAuth || to.meta.roles || to.meta.role) {
        return next("/login");
      }

      return next();
    }
  });
}
